import React, { useContext } from "react";
import { connect } from "react-redux";
import {
  deleteQuickList,
  getQuickLists,
  getQuickListCount,
  getQuickListTemplates,
  getQuickListResult,
  saveQuickList,
  saveQuickListGroup,
  setCurrentQuicklistId,
  setCurrentQuicklistRowIndex,
} from "actions/homeowner/quickList";
import { getCaseHeader, getHistory, updateCaseHeader } from "actions/homeowner/caseforms";
import StaticQuickLists from "components/QuickLists";
import { getGridFilterMenus } from "actions/homeowner/dashboard";
import { getAppraiserManagers, getStateList, getMinimalAppraiserList } from "actions/appraiser";
import { getCustomerServiceAssignToUsers } from "actions/customerService";
import { updateHeader, clearHeader, clearHeaderDefinitions } from 'actions/layout';
import { getAllSurveyTypes } from 'actions/user';
import { getCaseLocationsCount } from 'actions/assignment';
import { getMinimalFieldRepList } from "actions/homeowner/fieldReps";
import { getAllUnderwritersForUserRedux } from "requests/underwriter";
import {
  BROKER_CASE_HEADER,
  ASSIGNMENTTOOLINSURANCE,
  ASSIGNMENTTOOLAPPRAISAL,
  QUALITY_REVIEW_ASSIGN,
  CUSTOMER_SERVICE_INCIDENT_UPDATE,
  FIELD_SERVICE_AUTO_QA_BATCH_ADD,
  QUICKLIST_EDIT,
  FORM_PHOTO_VIEWER_SPLIT_VIEW,
  ORDER,
  CASE_HEADER_RIGHT_FILTERED_VIEW,
  APPRAISER_VIEW,
  EMPLOYEE_CONTACT_VIEW,
  EXPORTS_AVAILABLE_VIEW,
  FIELDREPPROFILE_VIEW,
  QUICKLIST_SHARE,
  QUICKLIST_GROUP_SHARE,
  CASE_HOLD_UPDATE,
  FIELD_SCHEDULING_MANAGE,
  QUICK_FILTERS_USE,
 } from "typeConstants/rights";
import {
  getAllBusOpsDirectorsRedux,
  getAllFieldDevelopmentManagersRedux,
  getAllLenderLogisticsManagers,
  getAllBusOpsManagersRedux,
  getAllFieldOperationsManagers,
  getAllCustomerExperienceManagers,
  getAllCustomerExperienceDirectors,
} from "requests/employee";
import { getAllCustomerActionsForUser } from "actions/underwriterActions";
import { getValuationCoordinators, getValuationDirectors } from "requests/appraiser";
import { getExportTypes } from "requests/exportTypes";
import responseHandler from "responseHandler";
import { getAllCounties, getAllServiceRegions } from "actions/region";
import { underwritersSelector, allFieldDevelopmentManagersSelector } from "selectors/menuItems";
import { userHasRight } from "selectors/rights";
import { ServiceTypeEnum } from "typeConstants/ServiceTypeEnum";
import { QuickFilterContext } from "components/QuickLists/QuickFilterProvider.tsx";

const mapStateToProps = state => {
  return {
    rights: state.user.profile.rights,
    isFetchingQuickLists: state.quickList.isFetchingQuickLists,
    quickLists: state.quickList.quickLists,
    quickListTemplates: state.quickList.quickListTemplates,

    stateList: state.appraiser.stateList,
    fetchingStateList: state.appraiser.fetchingStateList,
    gotInitialGridFilterMenus: state.dashboard.gotInitialGridFilterMenus,
    fetchingGridFilterMenus: state.dashboard.fetchingGridFilterMenus,
    fetchingAllSurveyTypesList: state.user.isFetchingAllSurveyTypesList,
    allSurveyTypes: state.user.allSurveyTypes,
    appraisalCaseCount: state.assignment.appraisalCaseCount,
    insuranceCaseCount: state.assignment.insuranceCaseCount,
    roles: state.user.profile.roles,
    caseHeader: state.caseForms.caseHeader,

    selectedCaseHistory: state.caseForms.caseHistory,
    fetchingCaseHistory: state.caseForms.fetchingHistory,
    updatingCaseHeader: state.caseForms.updatingCaseHeader,
    FRList: state.fieldRep.fieldRepsBasic,
    isFetchingFRList: state.fieldRep.isFetchingFieldReps,
    isFetchingAssignToUsers: state.customerService.isFetchingAssignToUsers,
    assignToUsers: state.customerService.assignToUsers,
    underwriters: underwritersSelector(state),
    fetchingUnderwriters: state.customer.fetchingUnderwriters,
    displayBrokerCaseHeader: userHasRight(BROKER_CASE_HEADER)(state),
    fetchingBusOpsDirectors: state.employee.fetchingBusOpsDirectors,
    busOpsDirectors: state.employee.busOpsDirectors,
    fetchingBusOpsManagers: state.employee.fetchingBusOpsManagers,
    busOpsManagers: state.employee.busOpsManagers,
    minimalAppraiserList: state.appraiser.minimalAppraiserList,
    fetchingMinimalAppraiserList: state.appraiser.fetchingMinimalAppraiserList,
    appraiserManagers: state.appraiser.appraiserManagers,
    fetchingAppraiserManagers: state.appraiser.fetchingAppraiserManagers,
    fetchingAllCustomerActionsForUser: state.homeownerCustomer.fetchingAllCustomerActionsForUser,
    allCustomerActionsForUser: state.homeownerCustomer.allCustomerActionsForUser,
    valuationCoordinators: state.appraiser.valuationCoordinators,
    fetchingValuationCoordinators: state.appraiser.fetchingValuationCoordinators,
    valuationDirectors: state.appraiser.valuationDirectors,
    fetchingValuationDirectors: state.appraiser.fetchingValuationDirectors,
    isFetchingAllCounties: state.region.isFetchingAllCounties,
    allCounties: state.region.allCounties,
    exportTypes: state.exportTypes.exportTypeResults,
    fetchingExportTypes: state.exportTypes.fetchingExportTypes,
    fetchingFieldDevelopmentManagers: state.employee.fetchingFieldDevelopmentManagers,
    fieldDevelopmentManagers: allFieldDevelopmentManagersSelector(state),
    isFetchingLenderLogisticsManagers: state.employee.isFetchingLenderLogisticsManagers,
    lenderLogisticsManagers: state.employee.lenderLogisticsManagers,
    canAssignField: userHasRight(ASSIGNMENTTOOLINSURANCE)(state) || userHasRight(ASSIGNMENTTOOLAPPRAISAL)(state),
    canAssignQA: userHasRight(QUALITY_REVIEW_ASSIGN)(state),
    canAssignIncidents: userHasRight(CUSTOMER_SERVICE_INCIDENT_UPDATE)(state),
    canAddBulkAutoQA: userHasRight(FIELD_SERVICE_AUTO_QA_BATCH_ADD)(state),
    canEditQuicklists: userHasRight(QUICKLIST_EDIT)(state),
    hasFormPhotoSplitView: userHasRight(FORM_PHOTO_VIEWER_SPLIT_VIEW)(state),
    canOrder: userHasRight(ORDER)(state),
    showCaseHeaderV2: userHasRight(CASE_HEADER_RIGHT_FILTERED_VIEW)(state),
    canViewAppraisers: userHasRight(APPRAISER_VIEW)(state),
    canViewEmployeeContactInfo: userHasRight(EMPLOYEE_CONTACT_VIEW)(state),
    canViewExports: userHasRight(EXPORTS_AVAILABLE_VIEW)(state),
    canViewFrProfile: userHasRight(FIELDREPPROFILE_VIEW)(state),
    canShareQuicklists: userHasRight(QUICKLIST_SHARE)(state),
    canShareQuicklistGroup: userHasRight(QUICKLIST_GROUP_SHARE)(state),
    canBulkPutOnHold: userHasRight(CASE_HOLD_UPDATE)(state),
    serviceRegions: state.region.serviceRegions,
    fieldOperationsManager: state.employee.fieldOperationsManagers,
    isFetchingFieldOperationsManagers: state.employee.isFetchingFieldOperationsManagers,
    isFetchingCustomerExperienceManagers: state.employee.isFetchingCustomerExperienceManagers,
    isFetchingCustomerExperienceDirectors: state.employee.isFetchingCustomerExperienceDirectors,
    currentQuicklistId: state.quickList.currentQuicklistId,
    currentRowIndex: state.quickList.currentRowIndex,
    internetUserId: state.user.profile.internetUserId,
    canManageFieldScheduling: userHasRight(FIELD_SCHEDULING_MANAGE)(state),
    customerExperienceManagers: state.employee.customerExperienceManagers,
    customerExperienceDirectors: state.employee.customerExperienceDirectors,
    hasQuickFilters: userHasRight(QUICK_FILTERS_USE)(state),
  };
};

const mapDispatchToProps = dispatch => ({
  deleteQuickList(quickList) {
    dispatch(deleteQuickList(quickList));
  },
  getQuickLists(refreshList, callback) {
    dispatch(getQuickLists(refreshList));
    dispatch(getQuickListTemplates(callback));
  },
  getQuickListCount(quickList, quickFilters) {
    dispatch(getQuickListCount(quickList, quickFilters));
  },
  getQuickListResult(quickList, quickFilters) {
    dispatch(getQuickListResult(quickList, quickFilters));
  },
  saveQuickList(quickList) {
    dispatch(saveQuickList(quickList));
  },
  saveQuickListGroup(items) {
    dispatch(saveQuickListGroup(items));
  },
  getStateList() {
    dispatch(getStateList());
  },
  getAllSurveyTypes() {
    dispatch(getAllSurveyTypes());
  },
  getAppraiserManagers() {
    dispatch(getAppraiserManagers());
  },
  getValuationCoordinators() {
    dispatch(getValuationCoordinators());
  },
  getValuationDirectors() {
    dispatch(getValuationDirectors());
  },
  getGridFilterMenus() {
    dispatch(getGridFilterMenus());
  },
  getCaseLocationsCount(mode, stateCodeList, caseIdFilter) {
    dispatch(getCaseLocationsCount(mode, stateCodeList, caseIdFilter));
  },
  getCaseHeader(caseId) {
    dispatch(getCaseHeader(caseId));
  },
  getHistory(controlNumber) {
    dispatch(getHistory(controlNumber));
  },
  getFRList() {
    dispatch(getMinimalFieldRepList());
  },
  updateCaseHeader(controlNumber, dto) {
    dispatch(updateCaseHeader(controlNumber, dto));
  },
  updateHeader(headerDefinitions) {
    dispatch(updateHeader(headerDefinitions));
  },
  clearHeader() {
    dispatch(clearHeader());
  },
  clearHeaderDefinitions(headerDefinitions) {
    dispatch(clearHeaderDefinitions(headerDefinitions));
  },
  getCustomerServiceAssignToUsers() {
    dispatch(getCustomerServiceAssignToUsers());
  },
  getUnderwriters() {
    dispatch(getAllUnderwritersForUserRedux());
  },
  getBusOpsDirectors() {
    dispatch(getAllBusOpsDirectorsRedux());
  },
  getBusOpsManagers() {
    dispatch(getAllBusOpsManagersRedux());
  },
  getMinimalAppraiserList() {
    dispatch(getMinimalAppraiserList());
  },
  getAllCustomerActionsForUser() {
    dispatch(getAllCustomerActionsForUser());
  },
  getAllCounties() {
    dispatch(getAllCounties());
  },
  makeToast(text, type) {
    responseHandler.customToast(text, type, dispatch);
  },
  getExportTypes(){
    dispatch(getExportTypes());
  },
  getAllFieldDevelopmentManagers(){
    dispatch(getAllFieldDevelopmentManagersRedux());
  },
  getAllLenderLogisticsManagers() {
    dispatch(getAllLenderLogisticsManagers());
  },
  getAllServiceRegions() {
    dispatch(getAllServiceRegions(ServiceTypeEnum.Inspector));
  },
  getAllFieldOperationsManagers() {
    dispatch(getAllFieldOperationsManagers());
  },
  setCurrentQuicklistId(id){
    dispatch(setCurrentQuicklistId(id));
  },
  setCurrentQuicklistRowIndex(index){
    dispatch(setCurrentQuicklistRowIndex(index));
  },
  getCustomerExperienceManagers() {
    dispatch(getAllCustomerExperienceManagers());
  },
  getCustomerExperienceDirectors() {
    dispatch(getAllCustomerExperienceDirectors());
  },
});

const StaticQuickListsWithQuickFilterProvider = props => {
  const context = useContext(QuickFilterContext);

  return <StaticQuickLists {...props} quickFilterContext={context} />;
};

const ConnectedStaticQuickLists = connect(
  mapStateToProps,
  mapDispatchToProps
)(StaticQuickListsWithQuickFilterProvider);

export default ConnectedStaticQuickLists;
